import { getOnboardingSteps } from "@yardzen/rest-api-client";
import useSWR from "swr";

export const useOnboarding = (accountId: string, designProjectId: string) => {
  const { data, error, isLoading } = useSWR(
    accountId && designProjectId
      ? `/accounts/${accountId}/design-projects/${designProjectId}/onboarding`
      : null,
    accountId && designProjectId
      ? () => getOnboardingSteps(accountId, designProjectId)
      : null,
  );

  return {
    onboarding: data?.data,
    isLoading,
    isError: error,
  };
};
